import React from "react";
import brazil from "../../../../../../utils/geojsons/br-geojson-1.json";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
function BrazilGeoMap({ data }) {
  const style = {
    height: "100%",
    width: "100%",
  };
  const option = {
    geo: {
      map: "brazil",
      aspectScale: 1,
      label: {
        normal: {
          show: false,
        },
        emphasis: {
          show: true,
          textStyle: {
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
          },
        },
      },
      nameProperty: "uf",
      roam: false,
      zoom: 1.2,
      itemStyle: {
        normal: {
          borderColor: "#eee",
          borderWidth: 1,
        },
        emphasis: {
          areaColor: "#8DCBF2",
          borderWidth: 1,
        },
      },
      zlevel: 1,
    },
    tooltip: {
      trigger: "item",
      showDelay: 0,
      transitionDuration: 0.2,
      formatter: function (params) {
        var value;
        if (params.value) {
          value = (params.value + "").split(".");
          return (
            params.seriesName +
            "<br/>" +
            params.name +
            ": <strong>" +
            value +
            "%</strong>"
          );
        }
        return (
          params.seriesName +
          "<br/>" +
          params.name +
          ": <strong>sem dados</strong>"
        );
      },
    },
    visualMap: {
      orient: `${window.innerWidth <= 360 ? "horizontal" : "vertical"}`,
      left: `${window.innerWidth <= 360 ? "center" : "right"}`,
      min: Math.floor(parseFloat(data.intervalo.min)),
      max: Math.ceil(parseFloat(data.intervalo.max)),
      textStyle: {
        fontWeight: "bold",
        color: "#777",
      },
      inRange: {
        color: ["#ffffe0", "#FFEDA0", "#e57a51", "#93003a"],
      },
      text: [
        `${Math.ceil(parseFloat(data.intervalo.max))}%`,
        `${Math.floor(parseFloat(data.intervalo.min))}%`,
      ],
      calculable: false,
    },
    series: [
      {
        nameProperty: "uf",
        name: "Porcentagem",
        type: "map",
        data: data.dados.map((estado) => {
          return { name: estado.uf, value: estado.porcent_confirmada };
        }),
        geoIndex: 0,
        zlevel: 3,
      },
    ],
  };
  echarts.registerMap("brazil", brazil);

  return (
    <>
      <ReactECharts option={option} style={style} />
    </>
  );
}

export default BrazilGeoMap;
